import { View } from 'react-native';
import React from 'react';
import Animated, { useAnimatedStyle, SharedValue } from 'react-native-reanimated';
import { styles } from './LegerPreviewBackground.styles';

type LegerPreviewBackgroundProps = {
  viewBox: { width: number; height: number; x: number; y: number };
  scaleSV: SharedValue<number>;
  zIndex: number;
};

export const LegerPreviewBackground = ({ viewBox, scaleSV, zIndex }: LegerPreviewBackgroundProps) => {
  const animatedStyle = useAnimatedStyle(() => ({
    width: viewBox.width * scaleSV.value,
    height: viewBox.height * scaleSV.value,
    top: viewBox.y * scaleSV.value,
    left: viewBox.x * scaleSV.value,
    zIndex,
  }));

  return (
    <Animated.View style={[styles.legerPreviewContainer, animatedStyle]}>
      <View style={styles.legerPreviewShadow} />
      <View style={styles.legerPreviewWhite} />
    </Animated.View>
  );
};
